import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ObtenerConfiguracionSalesForceService } from '../../../public/services/obtener-configuracion-sales-force.service';
import { ConfiguracionSalesforce } from '../../../public/interfaces/configuracion-sales-force';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-boton-cerrar-sesion-salesforce',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './boton-cerrar-sesion-salesforce.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './boton-cerrar-sesion-salesforce.component.css',
})
export class BotonCerrarSesionSalesforceComponent {
  protected readonly btoa = btoa;
  protected salesforceToken: string | null;
  protected configuracionSalesforce: ConfiguracionSalesforce;
  protected urlCallbackLogout: string;

  constructor(
    private obtenerConfiguracionSalesForceService: ObtenerConfiguracionSalesForceService,
  ) {
    this.configuracionSalesforce =
      this.obtenerConfiguracionSalesForceService.configuracionSalesForce;
    this.urlCallbackLogout = btoa(
      this.configuracionSalesforce.logout_callback_uri,
    );
    this.salesforceToken = sessionStorage.getItem('sales_force_token');
  }

  protected readonly sessionStorage = sessionStorage;
}
